import type { GrantEntry, RoleOption } from "../../shared/rbac/roles";
import { Dropdown } from "./Dropdown";
import { Icon } from "./Icon";
import { OverflowBadges } from "./Settings/OverflowBadges";
import { PillBadge } from "./Settings/shared";

type Props = {
  roles: string[];
  grants: GrantEntry[];
  roleOptions: RoleOption[];
  canManage: boolean;
  onToggle: (opt: RoleOption) => void;
};

export function RolePills({
  roles,
  grants,
  roleOptions,
  canManage,
  onToggle,
}: Props) {
  const badges =
    roles.length === 0 ? (
      <PillBadge
        icon="id-card-lanyard"
        interactive={canManage}
        style={{ flexShrink: 0 }}
      >
        Choose roles
      </PillBadge>
    ) : (
      <OverflowBadges
        items={roles}
        keyFn={(r) => r}
        renderBadge={(r) => (
          <PillBadge
            icon="id-card-lanyard"
            interactive={canManage}
            style={{ flexShrink: 0 }}
          >
            {r}
          </PillBadge>
        )}
        overflowTooltip={(hidden) => hidden.join(", ")}
      />
    );

  if (!canManage) return badges;

  return (
    <div
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <Dropdown
        opener={badges}
        align="bottom-left"
        minWidth={160}
        sections={[
          {
            items: roleOptions.map((opt) => ({
              type: "button" as const,
              keepOpen: true,
              left: <Icon name="id-card-lanyard" size={16} />,
              label: opt.label,
              right: grants.some(
                (g) =>
                  (opt.builtinRoleId &&
                    g.builtinRoleId === opt.builtinRoleId) ||
                  (opt.customRoleId && g.customRoleId === opt.customRoleId)
              ) ? (
                <Icon name="check" size={12} color="var(--text-secondary)" />
              ) : undefined,
              onClick: () => onToggle(opt),
            })),
          },
        ]}
      />
    </div>
  );
}
